document.addEventListener("DOMContentLoaded", () => {
  document.documentElement.addEventListener("cart:change", (e) => {
    ratingSnippet("db-0017-rating-snippet", {
      store: "deichbrise",
      mode: "default",
      linebreak: false,
      text: "",
      singularText: "",
      lang: "de",
      usePolaris: true,
      showEmptyStars: false,
    });

    setTimeout(() => {
      ratingSnippet("db-0017-rating-snippet", {
        store: "deichbrise",
        mode: "default",
        linebreak: false,
        text: "",
        singularText: "",
        lang: "de",
        usePolaris: true,
        showEmptyStars: false,
      });
    }, 1500);
  });

  document.documentElement.addEventListener("cart:refresh", (e) => {
    console.log("CART CHANGED");

    ratingSnippet("db-0017-rating-snippet", {
      store: "deichbrise",
      mode: "default",
      color: "#E27E3A",
      linebreak: false,
      text: "",
      singularText: "",
      lang: "de",
      usePolaris: true,
      showEmptyStars: false,
    });
  });
});